import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import EmailSignup from './components/EmailSignup';
import Footer from './components/Footer';
import About from './components/About';
import AboutOld from './components/AboutOld';
import AcceptInvitation from './components/AcceptInvitation';

function HomePage() {
  return (
    <>
      <div className="announcement-banner">
        <span>Coming Summer 2026</span>
        <a href="#signup" className="banner-button">Get Notified</a>
      </div>
      <Hero />
      <EmailSignup />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-old" element={<AboutOld />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
